export default __webpack_public_path__ + "static/media/330_business05-nl-web.bf03a624.png";